export default __webpack_public_path__ + "static/media/delete-row.7a7fc79b.svg";